// src/component/EventsPage.js
import React, { useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlaceIcon from "@mui/icons-material/Place";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import SortIcon from "@mui/icons-material/Sort";

// 日付文字列パース（例: "4月20日(日)" → 比較用数値）
function parseDateKey(dateStr) {
  const m = dateStr.match(/(\d+)月(\d+)日/);
  if (!m) return 99999;
  return parseInt(m[1], 10) * 100 + parseInt(m[2], 10);
}

// カテゴリ順の定義
const CATEGORY_ORDER = ["honbu", "chiiki", "jimukyoku", "group"];

// カテゴリ定義（色付き）
const CATEGORIES = [
  { key: "all", label: "すべて", color: "#4070e0", bg: "#e8eef8", stripe: "#4070e0" },
  { key: "honbu", label: "本部主催", color: "#c0392b", bg: "#fdeaea", stripe: "#c0392b" },
  { key: "chiiki", label: "各地域", color: "#27ae60", bg: "#e8f8ee", stripe: "#27ae60" },
  { key: "jimukyoku", label: "事務局", color: "#e67e22", bg: "#fdf2e6", stripe: "#e67e22" },
  { key: "group", label: "グループ", color: "#8e44ad", bg: "#f3e8fa", stripe: "#8e44ad" },
];

// 画像URL
const IMAGES = [
  "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1531058020387-3be344556be6?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1511578314322-379afb476865?w=600&h=400&fit=crop",
  "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600&h=400&fit=crop",
];

// 40件のイベントデータ（詳細情報付き）
const EVENTS = [
  // 本部主催
  { title: "テクノ未来音楽フェスティバル", date: "4月20日(日)", time: "14:00〜18:00", location: "サロンホール", category: "honbu", finished: false, buttonLabel: "チケット購入", capacity: "300名", organizer: "セカイムラ本部", description: "最新テクノロジーと音楽が融合する未来型フェスティバル。国内外のアーティストが集結し、新しい音楽体験をお届けします。ライブパフォーマンス、DJ セット、インタラクティブなインスタレーションをお楽しみください。" },
  { title: "第117回満月会", date: "4月20日(日)", time: "20:00〜21:30", location: "ZOOMもしくはYouTube", category: "honbu", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "満月の夜に全国のメンバーがオンラインで集まります。月のエネルギーを感じながら、瞑想と分かち合いの時間を過ごしましょう。初参加の方も大歓迎です。" },
  { title: "春の全国オンライン大会", date: "4月27日(日)", time: "13:00〜17:00", location: "ZOOM", category: "honbu", finished: false, buttonLabel: "詳細", capacity: "500名", organizer: "セカイムラ本部", description: "年に一度の全国大会をオンラインで開催。各地域の活動報告、ゲスト講演、ワークショップなど盛りだくさんの内容です。" },
  { title: "新月瞑想会 特別版", date: "4月28日(月)", time: "6:00〜7:00", location: "ZOOM", category: "honbu", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "新月の朝に行う特別な瞑想会。心を静め、新しいサイクルの始まりを感じましょう。ガイド付き瞑想なので初めての方も安心してご参加いただけます。" },
  { title: "第118回満月会", date: "5月12日(月)", time: "20:00〜21:30", location: "ZOOMもしくはYouTube", category: "honbu", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "5月の満月会です。フラワームーンの美しいエネルギーの中で、感謝と繋がりのセッションを行います。" },
  { title: "夏至スペシャルイベント", date: "6月21日(土)", time: "10:00〜16:00", location: "東京ホール", category: "honbu", finished: false, buttonLabel: "チケット購入", capacity: "200名", organizer: "セカイムラ本部", description: "一年で最も昼が長い日に、太陽のエネルギーを最大限に受け取る特別イベント。ワークショップ、瞑想、交流会を通じて夏至のパワーを感じましょう。" },
  { title: "セカイムラ全国サミット2026", date: "7月5日(土)", time: "10:00〜18:00", location: "大阪コンベンションセンター", category: "honbu", finished: false, buttonLabel: "チケット購入", capacity: "1000名", organizer: "セカイムラ本部", description: "年間最大のイベント。全国のメンバーが一堂に会し、ビジョンの共有、ワークショップ、ネットワーキングを行います。オンライン参加も可能です。" },
  { title: "第116回満月会", date: "3月22日(土)", time: "20:00〜21:30", location: "ZOOM", category: "honbu", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "3月の満月会は春分直後の特別なタイミングで開催されました。多くの方にご参加いただきありがとうございました。" },
  { title: "春分の日 特別瞑想会", date: "3月20日(木)", time: "6:00〜7:00", location: "ZOOM", category: "honbu", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "春分の日の朝に行った特別瞑想会。新しい季節の始まりを心身で感じる時間となりました。" },
  { title: "第115回満月会", date: "2月20日(木)", time: "20:00〜21:30", location: "ZOOM", category: "honbu", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "セカイムラ本部", description: "スノームーンの満月会。冬の静寂の中で深い内省の時間を持ちました。" },

  // 各地域
  { title: "北海道ブロック交流会", date: "4月19日(土)", time: "13:00〜16:00", location: "札幌市民会館", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "50名", organizer: "北海道ブロック", description: "北海道メンバーの対面交流会。自己紹介、活動報告、グループワークを行います。お気軽にご参加ください。" },
  { title: "東北ブロック新月会", date: "4月28日(月)", time: "6:00〜7:00", location: "仙台ZOOM拠点", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "30名", organizer: "東北ブロック", description: "東北エリアの新月会。地域の拠点からオンラインで繋がり、新月の瞑想を一緒に行います。" },
  { title: "関東ブロック交流会", date: "5月3日(土)", time: "14:00〜17:00", location: "東京・渋谷会場", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "80名", organizer: "関東ブロック", description: "GW特別企画の対面交流会。ワークショップと懇親会を予定しています。関東近郊の方はぜひ！" },
  { title: "中部ブロック満月会", date: "5月12日(月)", time: "20:00〜21:30", location: "名古屋ZOOM拠点", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "40名", organizer: "中部ブロック", description: "中部エリアのメンバーで満月会を開催。名古屋の拠点から配信し、各地から参加できます。" },
  { title: "関西ブロック交流会", date: "5月17日(土)", time: "13:00〜16:00", location: "大阪・梅田会場", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "60名", organizer: "関西ブロック", description: "関西メンバーの対面交流会。テーマ別のグループディスカッションと交流ランチを予定しています。" },
  { title: "中国・四国ブロック交流会", date: "5月24日(土)", time: "13:00〜16:00", location: "広島ZOOM拠点", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "30名", organizer: "中国・四国ブロック", description: "中国・四国エリアの交流会。ハイブリッド開催で、対面とオンラインどちらからも参加可能です。" },
  { title: "九州ブロック新月会", date: "5月27日(火)", time: "6:00〜7:00", location: "福岡ZOOM拠点", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "30名", organizer: "九州ブロック", description: "九州エリアの新月会。福岡の拠点を中心に、オンラインで各県から参加できます。" },
  { title: "沖縄ブロック交流会", date: "6月7日(土)", time: "14:00〜17:00", location: "那覇市民会館", category: "chiiki", finished: false, buttonLabel: "詳細", capacity: "25名", organizer: "沖縄ブロック", description: "沖縄メンバーの対面交流会。海辺でのワークショップも予定しています。" },
  { title: "北信越ブロック交流会", date: "3月15日(土)", time: "13:00〜16:00", location: "新潟ZOOM拠点", category: "chiiki", finished: true, buttonLabel: "詳細", capacity: "25名", organizer: "北信越ブロック", description: "北信越エリアの交流会を開催しました。雪解けの季節にふさわしい温かい集まりとなりました。" },
  { title: "関西ブロック新月会", date: "3月1日(土)", time: "6:00〜7:00", location: "京都会場", category: "chiiki", finished: true, buttonLabel: "詳細", capacity: "40名", organizer: "関西ブロック", description: "京都の会場から配信した新月会。早朝にも関わらず多くの方にご参加いただきました。" },

  // 事務局
  { title: "新メンバー向けオリエンテーション", date: "4月22日(火)", time: "19:00〜20:30", location: "ZOOM", category: "jimukyoku", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "新しくメンバーになった方向けのオリエンテーション。活動の説明、ツールの使い方、Q&Aを行います。" },
  { title: "ZOOM操作説明会", date: "4月25日(金)", time: "10:00〜11:00", location: "ZOOM", category: "jimukyoku", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "ZOOMの基本操作から活用方法まで丁寧に説明します。オンラインイベント参加に不安がある方はぜひご参加ください。" },
  { title: "拠点リーダー研修会", date: "5月10日(土)", time: "10:00〜12:00", location: "ZOOM", category: "jimukyoku", finished: false, buttonLabel: "詳細", capacity: "50名", organizer: "事務局", description: "各地域の拠点リーダーを対象とした研修会。運営ノウハウの共有、課題解決のディスカッションを行います。" },
  { title: "事務局定期ミーティング", date: "5月15日(木)", time: "19:00〜20:00", location: "ZOOM", category: "jimukyoku", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "月次の事務局ミーティング。活動報告と今後の計画について話し合います。メンバーのオブザーバー参加も歓迎です。" },
  { title: "コミュニティ運営相談会", date: "5月20日(火)", time: "14:00〜15:30", location: "ZOOM", category: "jimukyoku", finished: false, buttonLabel: "詳細", capacity: "20名", organizer: "事務局", description: "グループやイベントの運営で困っていることを相談できる場です。事務局スタッフが丁寧にサポートします。" },
  { title: "サイトリニューアル説明会", date: "3月28日(金)", time: "19:00〜20:00", location: "ZOOM", category: "jimukyoku", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "新しいサイトの機能と使い方について説明しました。録画アーカイブをメンバーページで公開中です。" },
  { title: "年度末報告会", date: "3月25日(火)", time: "19:00〜20:30", location: "ZOOM", category: "jimukyoku", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "2025年度の活動報告と収支報告を行いました。来年度の計画についても共有しました。" },
  { title: "新年度キックオフ", date: "4月1日(火)", time: "10:00〜11:30", location: "ZOOM", category: "jimukyoku", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "2026年度のキックオフミーティング。新しいビジョンと年間計画を発表しました。" },
  { title: "会員アンケート結果発表会", date: "2月28日(金)", time: "19:00〜20:00", location: "ZOOM", category: "jimukyoku", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "事務局", description: "昨年末に実施した会員アンケートの結果を発表しました。貴重なご意見をありがとうございました。" },
  { title: "IT勉強会", date: "2月15日(土)", time: "14:00〜16:00", location: "ZOOM", category: "jimukyoku", finished: true, buttonLabel: "詳細", capacity: "30名", organizer: "事務局", description: "事務局主催のIT勉強会。各種ツールの活用方法やセキュリティについて学びました。" },

  // グループ
  { title: "カチャーシー全国zoomフォロー会 第4回", date: "4月21日(月)", time: "20:00〜21:00", location: "ZOOM", category: "group", finished: false, buttonLabel: "詳細", capacity: "制限なし", organizer: "カチャーシー部", description: "カチャーシーの練習フォロー会。動きのポイントを確認しながら、みんなで楽しく踊りましょう。初心者大歓迎！" },
  { title: "読書会「月のリズムと暮らし」", date: "4月26日(土)", time: "10:00〜11:30", location: "ZOOM", category: "group", finished: false, buttonLabel: "詳細", capacity: "15名", organizer: "読書部", description: "今回のテーマは「月のリズムと暮らし」。月の満ち欠けに合わせた暮らし方について語り合います。事前に課題図書をお読みください。" },
  { title: "ヨガ部 オンラインレッスン", date: "5月3日(土)", time: "8:00〜9:00", location: "ZOOM", category: "group", finished: false, buttonLabel: "詳細", capacity: "30名", organizer: "ヨガ部", description: "GW朝ヨガレッスン。心身をリフレッシュして素敵な休日の始まりにしましょう。初心者でも安心のプログラムです。" },
  { title: "料理部 春の薬膳クッキング", date: "5月8日(木)", time: "11:00〜13:00", location: "ZOOM", category: "group", finished: false, buttonLabel: "詳細", capacity: "20名", organizer: "料理部", description: "春の食材を使った薬膳料理を一緒に作りましょう。材料リストは事前にお送りします。ZOOMで画面を見ながら一緒にクッキング！" },
  { title: "音楽部 合同練習会", date: "5月11日(日)", time: "14:00〜16:00", location: "ZOOM", category: "group", finished: false, buttonLabel: "詳細", capacity: "25名", organizer: "音楽部", description: "7月のサミットに向けた合同練習会。各パートの練習と合わせを行います。楽器がなくても歌で参加OK！" },
  { title: "写真部 撮影会＆講評", date: "5月18日(日)", time: "10:00〜15:00", location: "各地域集合", category: "group", finished: false, buttonLabel: "詳細", capacity: "各拠点10名", organizer: "写真部", description: "各地域の拠点に集合して撮影会を行い、午後にオンラインで講評します。テーマは「春から夏へ」。" },
  { title: "農業部 田植え体験", date: "5月25日(日)", time: "9:00〜15:00", location: "千葉・佐倉市", category: "group", finished: false, buttonLabel: "詳細", capacity: "20名", organizer: "農業部", description: "実際の田んぼで田植え体験！昼食は地元食材を使ったお弁当付き。泥んこになって自然を感じましょう。長靴・着替え持参。" },
  { title: "カチャーシー全国zoomフォロー会 第3回", date: "3月23日(月)", time: "20:00〜21:00", location: "ZOOM", category: "group", finished: true, buttonLabel: "詳細", capacity: "制限なし", organizer: "カチャーシー部", description: "第3回のフォロー会を開催しました。30名以上の参加で盛り上がりました！" },
  { title: "読書会「地球の未来」", date: "3月8日(土)", time: "10:00〜11:30", location: "ZOOM", category: "group", finished: true, buttonLabel: "詳細", capacity: "15名", organizer: "読書部", description: "「地球の未来」をテーマにした読書会。環境問題から精神性まで幅広い議論ができました。" },
  { title: "ヨガ部 冬のリトリート", date: "2月22日(土)", time: "9:00〜12:00", location: "ZOOM", category: "group", finished: true, buttonLabel: "詳細", capacity: "30名", organizer: "ヨガ部", description: "冬の特別リトリート。3時間のたっぷりしたプログラムで心身を整えました。" },
];

// レイアウトパターン
const LAYOUTS = [
  { key: "card", label: "カード" },
  { key: "magazine", label: "マガジン" },
  { key: "compact", label: "コンパクト" },
];

// フッターナビ
const FOOTER_NAV = [
  { label: "ホーム", path: "/portal", underline: false },
  { label: "地球の活動", path: "/portal", underline: false },
  { label: "太陽の活動", path: "/portal", underline: false },
  { label: "月の活動", path: "/portal", underline: false },
  { label: "イベント", path: "/events", underline: true },
];

export default function EventsPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [hideFinished, setHideFinished] = useState(false);
  const [sortMode, setSortMode] = useState("date"); // "date" | "dateDesc" | "category"
  const [layout, setLayout] = useState("card");

  const handleDateSort = () => {
    setSortMode((prev) => (prev === "date" ? "dateDesc" : "date"));
  };

  const filtered = EVENTS.filter((e) => {
    if (activeCategory !== "all" && e.category !== activeCategory) return false;
    if (hideFinished && e.finished) return false;
    return true;
  });

  const sorted = [...filtered].sort((a, b) => {
    if (sortMode === "date") {
      return parseDateKey(a.date) - parseDateKey(b.date);
    }
    if (sortMode === "dateDesc") {
      return parseDateKey(b.date) - parseDateKey(a.date);
    }
    const catA = CATEGORY_ORDER.indexOf(a.category);
    const catB = CATEGORY_ORDER.indexOf(b.category);
    if (catA !== catB) return catA - catB;
    return parseDateKey(a.date) - parseDateKey(b.date);
  });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: { xs: 2, sm: 4 },
        px: 2,
        pb: 6,
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 648, overflow: "hidden" }}>
        {/* ── レイアウト切り替え ── */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 0.8,
            mb: 3,
          }}
        >
          {LAYOUTS.map((l) => (
            <Box
              key={l.key}
              onClick={() => setLayout(l.key)}
              sx={{
                px: 2.2,
                py: 0.7,
                borderRadius: "20px",
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
                userSelect: "none",
                transition: "all 0.2s ease",
                bgcolor: layout === l.key ? "#333" : "transparent",
                color: layout === l.key ? "#fff" : "#888",
                border: layout === l.key ? "1px solid #333" : "1px solid #ccc",
                "&:hover": { bgcolor: layout === l.key ? "#333" : "#f5f5f5" },
              }}
            >
              {l.label}
            </Box>
          ))}
        </Box>

        {/* タイトル */}
        <Typography
          sx={{
            fontSize: { xs: 24, sm: 32 },
            fontWeight: 800,
            textAlign: "center",
            mb: 3,
            color: "#222",
          }}
        >
          イベントカレンダー
        </Typography>

        {/* カテゴリフィルター */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            sx={{ fontSize: 14, fontWeight: 600, color: "#333", mb: 1.5 }}
          >
            カテゴリで絞り込む
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 1,
            }}
          >
            {CATEGORIES.map((cat) => (
              <Box
                key={cat.key}
                onClick={() => setActiveCategory(cat.key)}
                sx={{
                  px: 2.5,
                  py: 0.8,
                  borderRadius: "20px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  userSelect: "none",
                  transition: "all 0.15s ease",
                  bgcolor:
                    activeCategory === cat.key ? cat.color : "transparent",
                  color: activeCategory === cat.key ? "#fff" : cat.color,
                  border:
                    activeCategory === cat.key
                      ? `1px solid ${cat.color}`
                      : `1px solid ${cat.color}66`,
                  "&:hover": {
                    bgcolor:
                      activeCategory === cat.key ? cat.color : cat.bg,
                  },
                }}
              >
                {cat.label}
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              width: 40,
              height: 3,
              bgcolor: (CATEGORIES.find((c) => c.key === activeCategory) || CATEGORIES[0]).color,
              borderRadius: 2,
              mx: "auto",
              mt: 1.5,
            }}
          />
        </Box>

        {/* 件数表示 + 終了非表示 + 並び替え */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1, mb: 2 }}>
          <Box
            onClick={() => setHideFinished((v) => !v)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              cursor: "pointer",
              userSelect: "none",
              mr: "auto",
            }}
          >
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "3px",
                border: hideFinished ? "none" : "1.5px solid #bbb",
                bgcolor: hideFinished ? "#4070e0" : "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11,
                color: "#fff",
                fontWeight: 700,
                transition: "all 0.12s ease",
              }}
            >
              {hideFinished && "✓"}
            </Box>
            <Typography sx={{ fontSize: 12, color: "#666" }}>
              終了を非表示
            </Typography>
          </Box>
          <Typography sx={{ fontSize: 12, color: "#999" }}>
            {sorted.length}件のイベント
          </Typography>
          <Box sx={{ display: "flex", gap: 0.3, ml: 1 }}>
            <Box
              onClick={handleDateSort}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.3,
                px: 1.2,
                py: 0.4,
                borderRadius: "4px",
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer",
                userSelect: "none",
                bgcolor: (sortMode === "date" || sortMode === "dateDesc") ? "#4070e0" : "#eee",
                color: (sortMode === "date" || sortMode === "dateDesc") ? "#fff" : "#999",
                transition: "all 0.12s ease",
                "&:hover": { bgcolor: (sortMode === "date" || sortMode === "dateDesc") ? "#3060d0" : "#ddd" },
              }}
            >
              <SortIcon sx={{ fontSize: 14, transform: sortMode === "dateDesc" ? "scaleY(-1)" : "none", transition: "transform 0.2s ease" }} />
              日付{sortMode === "dateDesc" ? "↓" : "↑"}
            </Box>
            <Box
              onClick={() => setSortMode("category")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.3,
                px: 1.2,
                py: 0.4,
                borderRadius: "4px",
                fontSize: 11,
                fontWeight: 600,
                cursor: "pointer",
                userSelect: "none",
                bgcolor: sortMode === "category" ? "#4070e0" : "#eee",
                color: sortMode === "category" ? "#fff" : "#999",
                transition: "all 0.12s ease",
                "&:hover": { bgcolor: sortMode === "category" ? "#3060d0" : "#ddd" },
              }}
            >
              <SortIcon sx={{ fontSize: 14 }} />
              カテゴリ順
            </Box>
          </Box>
        </Box>

        {/* ══════════════════════════════════════════
            パターン1: カード（画像が上、テキストが下）
           ══════════════════════════════════════════ */}
        {layout === "card" && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "1fr 1fr 1fr",
            },
            gap: 3,
            mb: 8,
          }}
        >
          {sorted.map((ev, i) => {
            const cat = CATEGORIES.find((c) => c.key === ev.category) || CATEGORIES[0];
            return (
            <Box
              key={i}
              sx={{
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                border: `1px solid ${cat.color}30`,
                borderRadius: 2,
                cursor: "pointer",
                transition: "box-shadow 0.2s ease",
                "&:hover": { boxShadow: `0 4px 16px ${cat.color}20` },
              }}
              onClick={() => setSelectedEvent(ev)}
            >
              <Box sx={{ position: "relative" }}>
                <Box
                  component="img"
                  src={IMAGES[i % IMAGES.length]}
                  alt={ev.title}
                  sx={{
                    width: "100%",
                    height: { xs: 160, sm: 200 },
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 5, bgcolor: cat.stripe }} />
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    left: 8,
                    bgcolor: cat.bg,
                    px: 1.2,
                    py: 0.3,
                    borderRadius: "3px",
                    fontSize: 11,
                    fontWeight: 600,
                    color: cat.color,
                    border: `1px solid ${cat.color}40`,
                  }}
                >
                  {cat.label}
                </Box>
              </Box>

              <Box sx={{ pt: 2, pb: 2.5, px: 2, textAlign: "center", flexGrow: 1, display: "flex", flexDirection: "column" }}>
                {ev.finished && (
                  <Typography sx={{ display: "inline-block", fontSize: 11, fontWeight: 700, color: "#e04040", border: "1px solid #e04040", borderRadius: "3px", px: 1, py: 0.2, mb: 0.8, alignSelf: "center" }}>
                    終了
                  </Typography>
                )}
                <Typography sx={{ fontSize: { xs: 14, sm: 16 }, fontWeight: 700, color: "#222", mb: 0.5, lineHeight: 1.5 }}>
                  {ev.title}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#666", mb: 1.5 }}>
                  {ev.date}｜{ev.location}
                </Typography>
                <Typography sx={{ fontSize: 12, color: cat.color, textDecoration: "underline", mb: 2, "&:hover": { opacity: 0.7 } }}>
                  詳細を見る
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Box sx={{ display: "inline-block", bgcolor: ev.finished ? "#aaa" : cat.color, color: "#fff", fontSize: 13, fontWeight: 600, px: 3.5, py: 1, borderRadius: "4px", alignSelf: "center", transition: "all 0.15s ease", "&:hover": { bgcolor: ev.finished ? "#aaa" : `${cat.color}cc` } }}>
                  {ev.buttonLabel}
                </Box>
              </Box>
            </Box>
            );
          })}
        </Box>
        )}

        {/* ══════════════════════════════════════════
            パターン2: マガジン（画像が横、水平カード）
           ══════════════════════════════════════════ */}
        {layout === "magazine" && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, mb: 8 }}>
          {sorted.map((ev, i) => {
            const cat = CATEGORIES.find((c) => c.key === ev.category) || CATEGORIES[0];
            const imgRight = i % 2 === 1;
            return (
              <Box
                key={i}
                onClick={() => setSelectedEvent(ev)}
                sx={{
                  display: "flex",
                  flexDirection: imgRight ? "row-reverse" : "row",
                  border: `1px solid ${cat.color}25`,
                  borderRadius: 2,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "box-shadow 0.2s ease",
                  "&:hover": { boxShadow: `0 4px 20px ${cat.color}18` },
                  minHeight: { xs: 140, sm: 180 },
                }}
              >
                {/* 画像エリア */}
                <Box sx={{ position: "relative", width: { xs: "40%", sm: "38%" }, flexShrink: 0 }}>
                  <Box
                    component="img"
                    src={IMAGES[i % IMAGES.length]}
                    alt={ev.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      minHeight: { xs: 140, sm: 180 },
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: imgRight ? "auto" : 8,
                      right: imgRight ? 8 : "auto",
                      bgcolor: cat.bg,
                      px: 1,
                      py: 0.2,
                      borderRadius: "3px",
                      fontSize: 10,
                      fontWeight: 600,
                      color: cat.color,
                      border: `1px solid ${cat.color}40`,
                    }}
                  >
                    {cat.label}
                  </Box>
                  {/* カテゴリ色ライン（画像の内側端） */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      width: 4,
                      bgcolor: cat.stripe,
                      ...(imgRight ? { left: 0 } : { right: 0 }),
                    }}
                  />
                </Box>

                {/* テキストエリア */}
                <Box
                  sx={{
                    flex: 1,
                    p: { xs: 1.5, sm: 2.5 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    overflow: "hidden",
                  }}
                >
                  {ev.finished && (
                    <Typography sx={{ display: "inline-block", fontSize: 10, fontWeight: 700, color: "#e04040", border: "1px solid #e04040", borderRadius: "3px", px: 0.8, py: 0.1, mb: 0.5, alignSelf: "flex-start" }}>
                      終了
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: { xs: 14, sm: 16 },
                      fontWeight: 700,
                      color: "#222",
                      mb: 0.5,
                      lineHeight: 1.4,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {ev.title}
                  </Typography>
                  <Typography sx={{ fontSize: { xs: 11, sm: 12 }, color: "#666", mb: 0.3 }}>
                    {ev.date}　{ev.time}
                  </Typography>
                  <Typography sx={{ fontSize: { xs: 11, sm: 12 }, color: "#888", mb: 1.5 }}>
                    {ev.location}
                  </Typography>
                  <Box
                    sx={{
                      display: "inline-block",
                      alignSelf: "flex-start",
                      bgcolor: ev.finished ? "#aaa" : cat.color,
                      color: "#fff",
                      fontSize: { xs: 11, sm: 12 },
                      fontWeight: 600,
                      px: 2.5,
                      py: 0.7,
                      borderRadius: "4px",
                      transition: "all 0.15s ease",
                      "&:hover": { bgcolor: ev.finished ? "#aaa" : `${cat.color}cc` },
                    }}
                  >
                    {ev.buttonLabel}
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>
        )}

        {/* ══════════════════════════════════════════
            パターン3: コンパクト（小サムネイル＋情報を詰め込み）
           ══════════════════════════════════════════ */}
        {layout === "compact" && (
        <Box sx={{ mb: 8, display: "flex", flexDirection: "column", gap: 0 }}>
          {sorted.map((ev, i) => {
            const cat = CATEGORIES.find((c) => c.key === ev.category) || CATEGORIES[0];
            return (
              <Box
                key={i}
                onClick={() => setSelectedEvent(ev)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1.2, sm: 1.5 },
                  py: 1.2,
                  px: { xs: 1, sm: 1.5 },
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  transition: "background 0.12s ease",
                  "&:hover": { bgcolor: "#f8f8fa" },
                }}
              >
                {/* 小さいサムネイル */}
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: 56, sm: 72 },
                    height: { xs: 56, sm: 72 },
                    borderRadius: "8px",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={IMAGES[i % IMAGES.length]}
                    alt={ev.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  {/* カテゴリ色のボーダー（左端） */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: 0,
                      width: 3,
                      bgcolor: cat.stripe,
                    }}
                  />
                </Box>

                {/* 情報エリア */}
                <Box sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 0.3 }}>
                    <Box
                      sx={{
                        bgcolor: cat.bg,
                        color: cat.color,
                        fontSize: 9,
                        fontWeight: 700,
                        px: 0.8,
                        py: 0.15,
                        borderRadius: "3px",
                        whiteSpace: "nowrap",
                        border: `1px solid ${cat.color}30`,
                      }}
                    >
                      {cat.label}
                    </Box>
                    <Typography sx={{ fontSize: { xs: 10, sm: 11 }, color: "#999", whiteSpace: "nowrap" }}>
                      {ev.date}
                    </Typography>
                    <Typography sx={{ fontSize: { xs: 9, sm: 10 }, color: "#bbb", whiteSpace: "nowrap", display: { xs: "none", sm: "block" } }}>
                      {ev.time}
                    </Typography>
                    {ev.finished && (
                      <Typography sx={{ fontSize: 9, fontWeight: 700, color: "#e04040", border: "1px solid #e04040", borderRadius: "2px", px: 0.5, py: 0, lineHeight: 1.5 }}>
                        終了
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { xs: 13, sm: 14 },
                      fontWeight: 600,
                      color: "#222",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      lineHeight: 1.4,
                    }}
                  >
                    {ev.title}
                  </Typography>
                  <Typography sx={{ fontSize: { xs: 10, sm: 11 }, color: "#888", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {ev.location}　|　{ev.organizer}
                  </Typography>
                </Box>

                {/* 右端: 詳細リンク */}
                <Typography sx={{ fontSize: 11, color: cat.color, fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}>
                  詳細 &gt;
                </Typography>
              </Box>
            );
          })}
        </Box>
        )}

        {/* フッターナビ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#eae8e0",
            borderRadius: 1,
            overflow: "hidden",
          }}
        >
          {FOOTER_NAV.map((item) => (
            <Box
              key={item.label}
              onClick={() => navigate(item.path)}
              sx={{
                px: { xs: 1.5, sm: 3 },
                py: 1.5,
                cursor: "pointer",
                fontSize: { xs: 11, sm: 14 },
                color: "#333",
                textDecoration: item.underline ? "underline" : "none",
                whiteSpace: "nowrap",
                "&:hover": { bgcolor: "rgba(0,0,0,0.05)" },
              }}
            >
              {item.label}
            </Box>
          ))}
          <Box
            sx={{
              px: { xs: 1, sm: 2 },
              py: 1.5,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              "&:hover": { bgcolor: "rgba(0,0,0,0.05)" },
            }}
          >
            <ChevronRightIcon sx={{ fontSize: 20, color: "#666" }} />
          </Box>
        </Box>
      </Box>

      {/* ── イベント詳細ダイアログ ── */}
      <Dialog
        open={Boolean(selectedEvent)}
        onClose={() => setSelectedEvent(null)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, overflow: "hidden" },
        }}
      >
        {selectedEvent && (() => {
          const dlgCat = CATEGORIES.find((c) => c.key === selectedEvent.category) || CATEGORIES[0];
          return (
          <>
            <Box sx={{ position: "relative" }}>
              <Box
                component="img"
                src={IMAGES[EVENTS.indexOf(selectedEvent) % IMAGES.length]}
                alt={selectedEvent.title}
                sx={{
                  width: "100%",
                  height: { xs: 160, sm: 220 },
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 5, bgcolor: dlgCat.stripe }} />
              {selectedEvent.finished && (
                <Box sx={{ position: "absolute", top: 12, right: 50, bgcolor: "#e04040", color: "#fff", fontSize: 12, fontWeight: 700, px: 1.5, py: 0.4, borderRadius: "3px" }}>
                  終了
                </Box>
              )}
              <IconButton
                onClick={() => setSelectedEvent(null)}
                sx={{ position: "absolute", top: 8, right: 8, bgcolor: "rgba(0,0,0,0.4)", color: "#fff", "&:hover": { bgcolor: "rgba(0,0,0,0.6)" } }}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ px: 3, pt: 2.5 }}>
              <Box sx={{ display: "inline-block", bgcolor: dlgCat.bg, color: dlgCat.color, fontSize: 11, fontWeight: 700, px: 1.5, py: 0.4, borderRadius: "12px", mb: 1.5 }}>
                {dlgCat.label}
              </Box>
            </Box>

            <DialogTitle sx={{ pt: 0.5, pb: 1, fontWeight: 800, fontSize: { xs: 18, sm: 22 }, color: "#222" }}>
              {selectedEvent.title}
            </DialogTitle>

            <DialogContent sx={{ pb: 3 }}>
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 3, p: 2, bgcolor: "#f8f8fa", borderRadius: 2 }}>
                <InfoRow icon={<CalendarTodayIcon sx={{ fontSize: 16 }} />} label="開催日" value={selectedEvent.date} color={dlgCat.color} />
                <InfoRow icon={<AccessTimeIcon sx={{ fontSize: 16 }} />} label="時間" value={selectedEvent.time} color={dlgCat.color} />
                <InfoRow icon={<PlaceIcon sx={{ fontSize: 16 }} />} label="会場" value={selectedEvent.location} color={dlgCat.color} />
                <InfoRow icon={<PersonIcon sx={{ fontSize: 16 }} />} label="定員" value={selectedEvent.capacity} color={dlgCat.color} />
              </Box>

              <Typography sx={{ fontSize: 12, color: "#999", mb: 1 }}>
                主催: {selectedEvent.organizer}
              </Typography>

              <Typography sx={{ fontSize: 14, color: "#444", lineHeight: 1.8, mb: 3 }}>
                {selectedEvent.description}
              </Typography>

              <Box sx={{ textAlign: "center" }}>
                <Box
                  onClick={() => setSelectedEvent(null)}
                  sx={{
                    display: "inline-block",
                    bgcolor: selectedEvent.finished ? "#aaa" : dlgCat.color,
                    color: "#fff",
                    fontSize: 15,
                    fontWeight: 700,
                    px: 5,
                    py: 1.3,
                    borderRadius: "6px",
                    cursor: selectedEvent.finished ? "default" : "pointer",
                    transition: "all 0.15s ease",
                    "&:hover": { bgcolor: selectedEvent.finished ? "#aaa" : `${dlgCat.color}cc` },
                  }}
                >
                  {selectedEvent.finished ? "このイベントは終了しました" : selectedEvent.buttonLabel}
                </Box>
              </Box>
            </DialogContent>
          </>
          );
        })()}
      </Dialog>
    </Box>
  );
}

function InfoRow({ icon, label, value, color = "#5b7de0" }) {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
      <Box sx={{ color, mt: 0.2 }}>{icon}</Box>
      <Box>
        <Typography sx={{ fontSize: 10, color: "#999", lineHeight: 1 }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 13, color: "#333", fontWeight: 600 }}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
}
